export default __webpack_public_path__ + "alberta-address.77c72c3af43dacc1141c.svg";